import {Inject, Injectable} from "@angular/core";
import "rxjs/add/operator/map";
import "rxjs/add/operator/subscribeOn";
import "rxjs/add/operator/share";
import {MicrophoneStatus, MicrophoneService} from "./microphone.service";
import {AudioFormatService} from "./audioformat.service";
import {EventBus} from "../../event/EventBus";
import {ClientConfiguration} from "../configuration/client.config";
import {BrowserAgent} from "../browser/browser.agent";
import {ModalConfig} from "../notification/modal.config";
import {BugsnagLoggingService} from "../logging/bugsnag-logging.service";

@Injectable()
export class MockMicrophoneService extends MicrophoneService {

    private source;

    constructor(audioFormat: AudioFormatService, clientConfigurationService: ClientConfiguration,
                eventBus: EventBus, browserAgent: BrowserAgent, log: BugsnagLoggingService, modalConfig: ModalConfig, @Inject(String)workerPath:string = '/base/src/resources/audioRecorderWorker.js') {

        super(audioFormat, clientConfigurationService, eventBus, browserAgent, log, modalConfig, workerPath);

    }

    get isMock(): boolean {
        return true;
    }

    public getAudioLengthSec(): number {
        return this.source.buffer.getChannelData(0).length / this.inputSampleRate;
    }

    private onAudioLoad = (audioData) => {
        // var audioData = this.httpRequest.response;
        console.log("got a buffer");
        this.context.decodeAudioData(audioData, (buffer) => {
                                         console.log("decoded buffer length " + buffer.getChannelData(0).length);
                                         this.source.buffer = buffer;

                                         // Sends a message, although this input only has one channel, so sending it
                                         // twice, since we are just taking the average.
                                         this.worker.postMessage({
                                                                     command: "record",
                                                                     buffer: [
                                                                         this.source.buffer.getChannelData(0),
                                                                         this.source.buffer.getChannelData(0)
                                                                     ],
                                                                     fromFile: true
                                                                 });
                                         this._microphoneStatusObserver.next(MicrophoneStatus.FILE_READ_COMPLETE);
                                     },
                                     (e) => {
                                         console.log("Error with decoding audio data" + e.err);
                                     });
    }

    public request(config?: Object): void {

        console.log("using mock microphone, request (device) method is a no-op");

    }

    public requestFile(fileName: string, config?: Object): void {
        // TODO: should not re-init audio processing and worker each file!
        this._microphoneStatusObserver.next(MicrophoneStatus.NOT_INITIALIZED);

        this.initSettings(config);
        // tslint:disable-next-line:no-string-literal
        window.AudioContext = window.AudioContext || window["webkitAudioContext"];
        this.context = new window.AudioContext();
        this.inputSampleRate = this.context.sampleRate;
        console.log("samplerate " + this.inputSampleRate);
        this.source = this.context.createBufferSource();
        // tslint:disable-next-line:no-string-literal
        window["firefox_audio_hack"] = this.source; // TODO: do we need this firefox hack for audio from file?
        let node = this.context.createScriptProcessor(this.inputBufferLength);
        this.source.connect(node);
        node.connect(this.context.destination);

        this.initWorker();
        this.worker.onmessage = this.onWorkerMessage;
        console.log("reading audio file:" + fileName);

        /*   if (this.http) {
         this.http.get(fileName).
         subscribe((res) => {
         this.onAudioLoad(res._body);
         },
         (error) => {
         console.log("Request failed with status: " + error);
         });
         } else {
         */
        // tslint:disable-next-line:no-string-literal
        window["fetch"](fileName,
                        {
                            method: "get"
                        })
            .then((response) => {
                if (response.ok) {
                    response.arrayBuffer().then((data) => {
                        this.onAudioLoad(data);
                    });
                } else {
                    console.log("Network response was not ok.");
                }
            })
            .catch((error) => {
                console.log("fetch error: " + error);
            });
        // }
        this._microphoneStatusObserver.next(MicrophoneStatus.READY);

    }
}
